export const INFO_TITLE = {
  addreses: 'addreses',
  paymentMethod: 'paymentMethod',
  coupons: 'coupons'
};

export const ICON_ADDRESS = {
  home: 'icon-home',
  couple: 'icon-heart',
  other: 'icon-location2',
  work: 'icon-tower'
};

export const DEFAULT_MAX_RESULTS = 3;
